var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import styles from './carousel-item.styles';
/**
 * @slot default - The component default content
 *
 * @csspart base - The component's base wrapper.
 * @csspart slide - The component's slide container.
 * @csspart part-default - The component's default slot.
 */
export class BlocksCarouselItem extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         * Caption Text for carousel slides
         */
        this.captionText = '';
        /**
         * Aria role description attribute, To be used only for accessibility
         * To define a localized and human-readable description for a role
         * If the aria-roledescription property is set to slide,
         * we should not set the aria-label property to slide because this would be redundant.
         */
        this.ariaroledescription = 'slide';
    }
    static { this.styles = styles; }
    render() {
        return html `<div part="base" class="cat-c-carousel-item-wrapper">
      <div part="slide" role="group" class="cat-c-carousel-item-slide">
        <slot part="part-default"></slot>
      </div>
    </div>`;
    }
}
__decorate([
    property({ type: String })
], BlocksCarouselItem.prototype, "captionText", void 0);
__decorate([
    property({ type: String })
], BlocksCarouselItem.prototype, "arialabel", void 0);
__decorate([
    property({ type: String })
], BlocksCarouselItem.prototype, "ariaroledescription", void 0);
if (customElements.get('cat-carousel-item') === undefined) {
    customElements.define('cat-carousel-item', BlocksCarouselItem);
}
